import React from 'react';

import { Dialog } from '@mui/material';

import Button from '../common/Button';
import Warning from '../icons/Warning';

type ConfirmDeleteDialogProps = {
  open: boolean;
  secondaryActionText?: string;
  primaryActionText: string;
  handleSecondaryAction?: () => void;
  handleClose?: () => void;
  handlePrimaryAction: () => void;
  title?: string;
  content: React.ReactNode;
  isPending?: boolean;
  showIcon?: boolean;
};

const WarningDialog = ({
  open,
  handleClose,
  handleSecondaryAction,
  handlePrimaryAction,
  secondaryActionText,
  primaryActionText,
  title,
  content,
  isPending,
  showIcon = true,
}: ConfirmDeleteDialogProps) => (
  <Dialog
    open={open}
    onClose={handleClose ?? handleSecondaryAction}
    aria-labelledby="alertTitle"
    aria-describedby="alertContent"
  >
    <div className="flex flex-col gap-6 p-6">
      <h2 className="text-xl font-bold flex items-end gap-2">
        {showIcon && <Warning />}
        <p className="text-xl font-semibold">{title ?? 'Warning'}</p>
      </h2>
      <div className="text-[#666]">{content}</div>
      <div className="flex justify-end gap-3">
        {secondaryActionText && (
          <Button
            onClick={handleSecondaryAction}
            variant="outlined"
            disabled={isPending}
            tabIndex={3}
          >
            {secondaryActionText}
          </Button>
        )}
        {primaryActionText && (
          <Button
            onClick={handlePrimaryAction}
            tabIndex={2}
            variant="contained_red"
            disabled={isPending}
            loading={isPending}
          >
            {primaryActionText}
          </Button>
        )}
      </div>
    </div>
  </Dialog>
);

export default WarningDialog;
